import {useContext} from "react";
import AuthContext from "../context/auth/AuthContext";

//Get current user auth
export const useAuth = () => {
    return useContext(AuthContext);
}